import { http } from '@/core/helpers/http.helper';
import { Place } from './place.interface';

export class PlaceService {
   async getPlaces(placeId: string) {
      const response = await http.get<Array<Place>>(`/places/${placeId}`);
      return response.data;
   }
}
